import {
  disclaimer as disclaimerAfs,
  privacy as privacyAfs,
} from '@/views/Login/wordings_afs';
import {
  disclaimer as disclaimerIpc,
  privacy as privacyIpc,
} from '@/views/Login/wordings_ipc';

const disclaimer = siteCode => {
  switch (siteCode) {
    case 'afs':
      return disclaimerAfs;
    case 'absg':
      return disclaimerAfs;
    case 'ipc':
      return disclaimerIpc;
    default:
      throw new Error();
  }
};

const privacy = siteCode => {
  switch (siteCode) {
    case 'afs':
      return privacyAfs;
    case 'absg':
      return privacyAfs;
    case 'ipc':
      return privacyIpc;
    default:
      throw new Error();
  }
};

export {disclaimer, privacy};
